/**
 * Generate downloadable source-file templates per import profile.
 */
import * as XLSX from 'xlsx';
import { PROFILES } from '../profiles/index';

const TEMPLATE_ROWS = {
  'gl9300c-budget': [
    {
      unit: 80,
      account: 701180,
      jan: 16800,
      feb: 16800,
      mar: 16800,
      apr: 16800,
      may: 16800,
      jun: 16800,
      jul: 16800,
      aug: 16800,
      sep: 16800,
      oct: 16800,
      nov: 16800,
      dec: 16800,
    },
    {
      unit: 80,
      account: 501100,
      jan: 250000,
      feb: 250000,
      mar: 250000,
      apr: 250000,
      may: 250000,
      jun: 250000,
      jul: 250000,
      aug: 250000,
      sep: 250000,
      oct: 250000,
      nov: 250000,
      dec: 250000,
    },
  ],
  'gl8610xl-je': [
    { unit: 80, account: 701180, debit: 5000, credit: '', description: 'Accrued expense' },
    { unit: 80, account: 200100, debit: '', credit: 5000, description: 'Offsetting entry' },
  ],
  'gl8610xl-payroll': [
    {
      date: '2026-06-17',
      unit: 1,
      account: 201240,
      amount: -40,
      description: 'WISMED DIRECT/PAC PAYABLE',
    },
    {
      date: '2026-06-17',
      unit: 105,
      account: 700000,
      amount: 11841.85,
      description: 'ADMINISTRATIVE SERVICES',
    },
    {
      date: '2026-06-17',
      unit: 1,
      account: 201730,
      amount: -63173.21,
      description: 'PAYROLL SUSPENSE',
    },
  ],
};

function toHeaderLabel(key) {
  const labels = {
    date: 'Date',
    unit: 'Unit',
    account: 'Account',
    amount: 'Amount',
    description: 'Desc',
  };
  if (labels[key]) return labels[key];
  return key
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

export function downloadTemplate(profileKey) {
  const profile = PROFILES[profileKey];
  if (!profile) throw new Error(`Unknown profile: ${profileKey}`);

  const rows = TEMPLATE_ROWS[profileKey] ?? [];
  const headers = profile.sourceColumns.map(toHeaderLabel);
  const data = rows.map((row) => {
    const out = {};
    profile.sourceColumns.forEach((col) => {
      out[toHeaderLabel(col)] = row[col] ?? '';
    });
    return out;
  });

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(data, { header: headers });
  XLSX.utils.book_append_sheet(wb, ws, 'Source Data');

  const filename = `${profile.interfaceId}_Source_Template.xlsx`;
  XLSX.writeFile(wb, filename);
}
